const caboVerde = {
  "title": "Sao Tome and Principe",
  "version": "1.1.2",
  "type": "FeatureCollection",
  "copyright": "Copyright (c) 2015 Highsoft AS, Based on data from Natural Earth",
  "copyrightShort": "Natural Earth",
  "copyrightUrl": "http://www.naturalearthdata.com",
  "crs": {
    "type": "name",
    "properties": {
      "name": "urn:ogc:def:crs:EPSG:32632"
    }
  },
  "hc-transform": {
    "default": {
      "crs": "+proj=utm +zone=32 +datum=WGS84 +units=m +no_defs",
      "scale": 0.00377802096809,
      "jsonres": 15.5,
      "jsonmarginX": -999,
      "jsonmarginY": 9851.0,
      "xoffset": 217457.645818,
      "yoffset": 187950.15804
    }
  },
  "features": [{
    "type": "Feature",
    "id": "ST.3593",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.51,
      "hc-middle-y": 0.44,
      "hc-key": "st-3593",
      "hc-a2": "ST",
      "labelrank": "20",
      "hasc": "ST.ST",
      "alt-name": null,
      "woe-id": "2347234",
      "subregion": null,
      "fips": "TP02",
      "postal-code": null,
      "name": "São Tomé",
      "country": "Sao Tome and Principe",
      "type-en": null,
      "region": null,
      "longitude": "6.61185",
      "woe-name": "Sao Tome",
      "latitude": "0.234574",
      "woe-label": "Sao Tome, ST, Sao Tome and Principe",
      "type": null
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [9, -649],
          [-209, -654],
          [-238, -649],
          [-307, -882],
          [-375, -972],
          [-461, -871],
          [-508, -984],
          [-576, -999],
          [-642, -937],
          [-683, -822],
          [-673, -814],
          [-641, -702],
          [-639, -649],
          [-660, -583],
          [-686, -555],
          [-712, -541],
          [-732, -517],
          [-962, 221],
          [-999, 284],
          [-969, 342],
          [-957, 399],
          [-954, 529],
          [-939, 580],
          [-813, 730],
          [-786, 788],
          [-779, 830],
          [-763, 871],
          [-533, 1100],
          [-483, 1124],
          [-238, 1207],
          [-34, 1374],
          [176, 1506],
          [434, 1482],
          [581, 1383],
          [732, 1222],
          [856, 1035],
          [924, 858],
          [953, 685],
          [950, 583],
          [924, 465],
          [872, 339],
          [817, 261],
          [657, 111],
          [576, 13],
          [389, -291],
          [350, -307],
          [289, -321],
          [251, -348],
          [294, -460],
          [246, -487],
          [173, -501],
          [122, -517],
          [22, -629],
          [9, -649]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "ST.6393",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.52,
      "hc-middle-y": 0.44,
      "hc-key": "st-6393",
      "hc-a2": "PR",
      "labelrank": "20",
      "hasc": "ST.PR",
      "alt-name": null,
      "woe-id": "2347233",
      "subregion": null,
      "fips": "TP01",
      "postal-code": null,
      "name": "Príncipe",
      "country": "Sao Tome and Principe",
      "type-en": null,
      "region": null,
      "longitude": "7.39374",
      "woe-name": "Principe",
      "latitude": "1.60769",
      "woe-label": "Principe, ST, Sao Tome and Principe",
      "type": null
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5348, 9303],
          [5355, 9157],
          [5322, 9028],
          [5290, 8964],
          [5242, 8936],
          [5161, 8923],
          [5137, 8886],
          [5139, 8830],
          [5132, 8759],
          [5115, 8784],
          [5095, 8832],
          [5084, 8851],
          [5041, 8832],
          [4999, 8804],
          [4942, 8908],
          [4852, 8939],
          [4757, 8945],
          [4683, 8981],
          [4663, 9181],
          [4668, 9300],
          [4728, 9290],
          [4836, 9335],
          [4889, 9395],
          [4905, 9476],
          [4906, 9581],
          [4940, 9705],
          [5028, 9803],
          [5143, 9851],
          [5262, 9825],
          [5441, 9808],
          [5513, 9776],
          [5532, 9687],
          [5497, 9658],
          [5424, 9629],
          [5350, 9586],
          [5311, 9515],
          [5407, 9499],
          [5493, 9453],
          [5526, 9404],
          [5466, 9382],
          [5373, 9360],
          [5348, 9303]
        ]
      ]
    }
  }]
};

export default caboVerde;
